export function exportTableToCsv(containerId, filename) {
    const container = document.getElementById(containerId);
    if (!container) return;
    const rows = Array.from(container.querySelectorAll("table tr"));
    const csv = rows
        .map((row) =>
            Array.from(row.querySelectorAll("th,td"))
                .map((cell) => `"${(cell.innerText || "").replace(/"/g, '""')}"`)
                .join(",")
        )
        .join("\n");
    const blob = new Blob([csv], {type: "text/csv;charset=utf-8;"});
    const link = document.createElement("a");
    const url = URL.createObjectURL(blob);
    link.href = url;
    link.setAttribute("download", filename);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
}

export function openTablePrintWindow(containerId) {
    const container = document.getElementById(containerId);
    if (!container) return;
    const tableHtml = container.querySelector("table")?.outerHTML || "";
    const w = window.open("", "_blank");
    if (!w) return;
    w.document.write(`
        <html>
        <head><title>Export</title></head>
        <body>${tableHtml}</body>
        </html>
    `);
    w.document.close();
    w.focus();
    w.print();
    w.close();
}
